import DefaultCRUD from '../utils'
const resource = `/railway`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
